import { render, staticRenderFns } from "./AdicionarDivida.vue?vue&type=template&id=50a14f6e&"
import script from "./AdicionarDivida.vue?vue&type=script&lang=js&"
export * from "./AdicionarDivida.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarDivida.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports